import React from 'react';
import css from './EditListingDetailsForm.module.css';
import classNames from 'classnames';
import { Field } from 'react-final-form';
import { FieldMultiSelect, FieldTextInput } from '../../../../components';
import { required } from '../../../../util/validators';
import { isArrayLength } from '../../../../util/genericHelpers';
import {
  createFilterOptions,
  createMultiFilterOptions,
  getLabel,
} from '../../../../components/CustomExtendedDataField/CustomExtendedDataField';
import { FieldConfigKey } from '../../../../util/enums';

const SocialMediaFields = ({ form, values, formId, filteredSocialMediaOptions, intl }) => {
  const { social_media } = values || {};
  const { SOCIAL_MEDIA } = FieldConfigKey;
  console.log(values, 'values');
  const socialMediaFieldConfig =
    isArrayLength(filteredSocialMediaOptions) &&
    filteredSocialMediaOptions?.find(config => config.key === SOCIAL_MEDIA);

  const { enumOptions, filterConfig, key, saveConfig } = socialMediaFieldConfig || {};
  const { placeholderMessage, isRequired, requiredMessage, defaultRequiredMessage } =
    saveConfig || {};

  const placeholder =
    placeholderMessage ||
    intl.formatMessage({ id: 'CustomExtendedDataField.placeholderSingleSelect' });
  const filterOptions = createFilterOptions(enumOptions);
  const label = getLabel(filterConfig);
  const validateMaybe = isRequired
    ? { validate: required(requiredMessage || defaultRequiredMessage) }
    : {};

  return (
    <div className={classNames(css.formRow, css.fullWidth)}>
      {isArrayLength(filterOptions) ? (
        <Field
          component={FieldMultiSelect}
          isMulti={true}
          id={formId ? `${formId}.${key}` : key}
          name={key}
          label={label}
          options={createMultiFilterOptions(enumOptions)}
          {...validateMaybe}
        />
      ) : null}

      {social_media && isArrayLength(social_media)
        ? social_media.map((media, index) => (
            <div key={media.value} className={classNames(css.formRow, css.fullWidth)}>
              <FieldTextInput
                id={`${formId}.social_media.${index}.socialLink`}
                name={`social_media[${index}].socialLink`}
                label={`${media.label} Link`}
                placeholder={`Enter your ${media.label} link`}
              />
            </div>
          ))
        : null}
    </div>
  );
};

export default SocialMediaFields;
